// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_DocumentID from "../Ouroboros.Models.Brands.DocumentID/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_SectionID from "../Ouroboros.Models.Brands.SectionID/index.js";
import * as Ouroboros_Models_Brands_SectionIndex from "../Ouroboros.Models.Brands.SectionIndex/index.js";
import * as Ouroboros_Models_Brands_SectionStatus from "../Ouroboros.Models.Brands.SectionStatus/index.js";
import * as Ouroboros_Models_Documents_Documents from "../Ouroboros.Models.Documents.Documents/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var readRecord = /* #__PURE__ */ Simple_JSON.readRecord();
var readFieldsCons = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
});
var readFieldsCons1 = /* #__PURE__ */ readFieldsCons(Ouroboros_Models_Brands_DocumentID.readDocumentID);
var readFieldsCons2 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "last_edited";
    }
});
var readFieldsCons3 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(Simple_JSON.readString);
var readFieldsCons4 = /* #__PURE__ */ readFieldsCons3(Simple_JSON.readFieldsNil)()();
var readRecord1 = /* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons1(/* #__PURE__ */ readFieldsCons2(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp)(readFieldsCons4)()())()());
var readRecord2 = /* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(Ouroboros_Models_Brands_SectionID.readSectionID)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(Ouroboros_Models_Brands_SectionIndex.readSectionIndex)(/* #__PURE__ */ readFieldsCons2(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp))(/* #__PURE__ */ readFieldsCons3(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "status";
    }
})(Ouroboros_Models_Brands_SectionStatus.readSectionStatus)(Simple_JSON.readFieldsNil)()())()())()())()())()());
var validateCreateDocumentResponse = function (response) {
    return Ouroboros_Models_Documents_Documents.isNonEmpty(response.prompting_question) && Ouroboros_Models_Documents_Documents.isUuid(Ouroboros_Models_Brands_DocumentID.unwrap(response.document_id));
};
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var readJson1 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "document";
    }
})(readRecord1)(Simple_JSON.readFieldsNil)()()));
var readJson2 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "outline";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(readRecord2))(Simple_JSON.readFieldsNil)()()));
var readJson3 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "documents";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(readRecord1))(Simple_JSON.readFieldsNil)()()));
var readJson4 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "document_contents";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "metadata";
    }
})(readRecord2)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "section_contents";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Simple_JSON.readString))(Simple_JSON.readFieldsNil)()())()())))(/* #__PURE__ */ readFieldsCons1(readFieldsCons4)()())()()));
var readJson5 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "document_id";
    }
})(Ouroboros_Models_Brands_DocumentID.readDocumentID)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "prompting_question";
    }
})(Simple_JSON.readString)(Simple_JSON.readFieldsNil)()())()()));
var failWith = function (message) {
    return new Data_Either.Left(message);
};
var decodeUploadSourceDocumentResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        var $118 = Ouroboros_Models_Documents_Documents.validateDocumentMetadata(decoded.document);
        if ($118) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid upload source document payload");
    });
};
var decodeOutlineResponse = function (value) {
    return bind(readJson2(value))(function (decoded) {
        var $119 = Data_Array.all(Ouroboros_Models_Documents_Documents.validateOutlineSection)(decoded.outline);
        if ($119) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid outline payload");
    });
};
var decodeListAvailableDocumentsResponse = function (value) {
    return bind(readJson3(value))(function (decoded) {
        var $120 = Data_Array.all(Ouroboros_Models_Documents_Documents.validateDocumentMetadata)(decoded.documents);
        if ($120) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid document list payload");
    });
};
var decodeDocumentFetchResponse = function (value) {
    return bind(readJson4(value))(function (decoded) {
        var $121 = Ouroboros_Models_Documents_Documents.validateUserDocument(decoded);
        if ($121) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid document payload");
    });
};
var decodeCreateDocumentResponse = function (value) {
    return bind(readJson5(value))(function (decoded) {
        var $122 = validateCreateDocumentResponse(decoded);
        if ($122) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid create document payload");
    });
};
export {
    decodeCreateDocumentResponse,
    decodeUploadSourceDocumentResponse,
    decodeListAvailableDocumentsResponse,
    decodeDocumentFetchResponse,
    decodeOutlineResponse
};
//# sourceMappingURL=index.js.map
